import { Button } from 'components/Button'
import { FlexGroup } from 'components/FlexGroup'
import { refresh } from 'utils/refresh'
import { useTranslation } from 'utils/translation'

import { Error as StyledError } from '../styles'

export const Error = () => {
  const { t } = useTranslation()
  return (
    <StyledError>
      <FlexGroup alignItems="center" gap={2} direction="row">
        {t('audio-player.failure')}
      </FlexGroup>
      <Button onClick={refresh}>{t('loading.try-again')}</Button>
    </StyledError>
  )
}
